import type { RouteRecordRaw } from "vue-router";
import type { RegistryNode } from "./registry/types";
import { backofficeRegistry, BACKOFFICE_V2_PREFIX } from "./registry";

const toRoutes = (nodes: RegistryNode[], depth = 0): RouteRecordRaw[] =>
  nodes.map((node): RouteRecordRaw => {
    const hasChildren = node.children.length > 0;
    const isEntity = "create" in node.config && typeof node.config.create === "function";

    const component =
      depth === 0
        ? () => import("@/v2/views/AdminView.vue")
        : isEntity
          ? () => import("@/v2/framework/view/GridView.vue")
          : () => import("@/views/PassthroughView.vue");

    return {
      path: isEntity ? `${node.segment}/:id?` : node.segment,
      meta: { title: node.config.title },
      component,
      ...(isEntity && { name: node.config.id }),
      ...(hasChildren && {
        redirect: `${BACKOFFICE_V2_PREFIX}${node.children[0]!.path}`,
        children: toRoutes(node.children, depth + 1),
      }),
    };
  });

export const createBackofficeRoutes = (): RouteRecordRaw[] => {
  const roots = backofficeRegistry.sections;
  const first = roots[0];
  return [
    {
      path: BACKOFFICE_V2_PREFIX,
      ...(first ? { redirect: `${BACKOFFICE_V2_PREFIX}${first.path}` } : {}),
      children: toRoutes(roots),
    },
  ];
};
